import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  deleteSipPlanRequest,
  deleteSipPlanSuccess,
  deleteSipPlanFailure,
  fetchSipPlansRequest,
  fetchSipPlansSuccess,
  fetchSipPlansFailure,
  createSipPlanRequest,
  createSipPlanSuccess,
  createSipPlanFailure,
  changeSipStatusRequest,
  changeSipStatusSuccess,
  changeSipStatusFailure,
  fetchAllSipListRequest,
  fetchAllSipListSuccess,
  fetchAllSipListFailure,
  getSipInstallmentsRequest,
  getSipInstallmentsSuccess,
  getSipInstallmentsFailure,
  updateLuckySpinRequest,
  updateLuckySpinSuccess,
  updateLuckySpinFailure,
  setCurrentSipPlan,
  fetchSpinHistoryRequest,
  fetchSpinHistorySuccess,
  fetchSpinHistoryFailure,
  fetchRunningSipsRequest,
  fetchRunningSipsSuccess,
  fetchRunningSipsFailure,
  fetchSipPlanNamesRequest,
  fetchSipPlanNamesSuccess,
  fetchSipPlanNamesFailure,
  changeLuckyDrawEligibilityRequest,
  changeLuckyDrawEligibilitySuccess,
  changeLuckyDrawEligibilityFailure,
} from "./SipPlanSlice";

function* createSipPlan(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/createOrEditSipPlan`,
      action.payload
    );
    
    if(response.data.success){
      window.location.reload();
    toast.success(response.data.message);
    yield put(createSipPlanSuccess());
    }else{
    yield put(createSipPlanFailure(response.data.message));
    toast.error(`Failed to create/edit SIP plan: ${response.data.message}`);
    } 
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(createSipPlanFailure(message));
    toast.error(`Failed to create/edit SIP plan: ${message}`);
  }
}

function* fetchSipPlans(action) {
  try {
    const { page = 1, limit = 5, search = "" } = action.payload || {};

    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/getsiptemplate`,
      {
        params: { page, limit, search },
      }
    );

    const result = response.data || {};
    yield put(fetchSipPlansSuccess(result));
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(fetchSipPlansFailure(message));
    toast.error(`Failed to fetch SIP plans: ${message}`);
  }
}
function* fetchSipPlanNamesSaga(action) {
  try {
    

    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/fetchsipplannames`,action.payload
    );

    const result = response.data || {};
    yield put(fetchSipPlanNamesSuccess(result.data));
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(fetchSipPlanNamesFailure(message));
    toast.error(`Failed to fetch SIP plans: ${message}`);
  }
}

function* deleteSipPlan(action) {
  try {
    yield call(
      axios.delete,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/deleteSIPPlan`,
      {
        data: { planid: action.payload },
      }
    );
    yield put(deleteSipPlanSuccess(action.payload));
    yield put(fetchSipPlansRequest());
    toast.success("SIP plan deleted successfully");
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(deleteSipPlanFailure(message));
    toast.error(`Failed to delete SIP plan: ${message}`);
  }
}

function* changeSipStatus(action) {
  try {
    const { planid, set_sip_status } = action.payload;
    yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/changeSipStatus`,
      {
        planid,
        set_sip_status,
      }
    );
    yield put(
      changeSipStatusSuccess({ planid, updatedStatus: set_sip_status })
    );
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(changeSipStatusFailure(message));
    toast.error(`Failed to change SIP status: ${message}`);
  }
}

function* fetchAllSipList(action) {
  try {
    const { id, page = 1, limit = 10, searchText = "" ,status = [],sipNames = []} = action.payload || {};

    const params = new URLSearchParams();
    if (id) params.append("id", id);
    params.append("page", page);
    params.append("limit", limit);
    if (searchText) params.append("search", searchText);
    if (status && status.length > 0) {
      params.append("status", status.join(",")); 
    }
    if (sipNames && sipNames.length > 0) {
      params.append("sipNames", sipNames.join(","));
    }

    const url = `${
      process.env.REACT_APP_API_BASE_URL
    }/api/v1/moneysip/getallSiplist?${params.toString()}`;

    const response = yield call(axios.get, url);
    const data = response.data || {};

    yield put(fetchAllSipListSuccess(data));
    toast.success("All SIP list fetched successfully");
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(fetchAllSipListFailure(message));
    toast.error(`Failed to fetch all SIP list: ${message}`);
  }
}
function* updateLuckySpinSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/changeluckyspinsipstatus`,
      action.payload
    );
    if (!response.data?.success) {
      const message = response.data?.message || "Lucky draw failed";
      yield put(updateLuckySpinFailure(message));
      toast.error(message);
      return;
    }
    const result = response.data.data || {};
    yield put(updateLuckySpinSuccess(result));
    toast.success(response.data?.message || "Lucky draw completed");
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(updateLuckySpinFailure(message));
    toast.error(`Failed to change SIP status: ${message}`);
  }
}
//get sipn history
function* fetchSpinHistorySaga(action) {
  try {
    const { sipplan } = action.payload;
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/sipnhistory/${sipplan}`
    );
    const spinHistory = response.data?.data || [];
    yield put(fetchSpinHistorySuccess(spinHistory));
  } catch (error) {
    yield put(
      fetchSpinHistoryFailure(error.response?.data?.message || error.message)
    );
  }
}
function* getSipInstallmentsSaga(action) {
  try {
    const sipId = action.payload;
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/getSipInstallments/${sipId}`
    );

    const data = response.data?.data || [];
    yield put(getSipInstallmentsSuccess(data));
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(getSipInstallmentsFailure(message));
    toast.error(`Failed to fetch SIP installments: ${message}`);
  }
}
//get running sips
function* fetchRunningSipsSaga(action) {
  try {
    const { sipplan } = action.payload;

    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/getRunningSips/${sipplan}`
    );

    const result = response.data?.data || [];
    yield put(fetchRunningSipsSuccess(result));
    toast.success("Running SIPs fetched successfully");
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(fetchRunningSipsFailure(message));
    toast.error(`Failed to fetch running SIPs: ${message}`);
  }
}

function* changeLuckyDrawEligibilitySaga(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/moneysip/change-lucky-draw-eligibility`,
      action.payload
    );

    const result = response.data || {};
    if (result.success === false) {
      throw new Error(result.message || "Unable to update lucky draw eligibility");
    }

    yield put(changeLuckyDrawEligibilitySuccess(action.payload));
    toast.success(result.message || "Lucky draw eligibility updated");
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(changeLuckyDrawEligibilityFailure(message));
    toast.error(`Failed to update lucky draw eligibility: ${message}`);
  }
}

export default function* SipPlanSaga() {
  yield takeLatest(createSipPlanRequest.type, createSipPlan);
  yield takeLatest(fetchSipPlansRequest.type, fetchSipPlans);
  yield takeLatest(deleteSipPlanRequest.type, deleteSipPlan);
  yield takeLatest(changeSipStatusRequest.type, changeSipStatus);
  yield takeLatest(fetchAllSipListRequest.type, fetchAllSipList);
  yield takeLatest(getSipInstallmentsRequest.type, getSipInstallmentsSaga);
  yield takeLatest(updateLuckySpinRequest.type, updateLuckySpinSaga);
  yield takeLatest(fetchSpinHistoryRequest.type, fetchSpinHistorySaga);
  yield takeLatest(fetchRunningSipsRequest.type, fetchRunningSipsSaga);
  yield takeLatest(fetchSipPlanNamesRequest.type, fetchSipPlanNamesSaga);
  yield takeLatest(
    changeLuckyDrawEligibilityRequest.type,
    changeLuckyDrawEligibilitySaga
  );
}
